import { openURL as openLink } from 'expo-linking';
import { Platform } from 'react-native';

function openURL(url: string) {
  if (Platform.OS === 'web') {
    return window.open(url, '_blank');
  } else {
    return openLink(url);
  }
}

export default openURL;
